// [Friendly Name, lowercase, API_Value]

const user_type = [
  ['Candidate', 'candidate', 0],
  ['Employer', 'employer', 1],
];

const employment_types = [
  ['Contract', 'contract', 'Contract'],
  ['Contract To Hire', 'contract to hire', 'Contract+To+Hire'],
  ['Direct Hire', 'direct hire', 'Direct+Hire'],
];

const industries = [
  ['Accounting', 'accounting', 'C11090'],
  ['Administrative', 'administrative', 'C44735'],
  ['Healthcare', 'healthcare', 'C69043'],
  // ['Human Resources', 'human resources', 'C50950'],
  ['IT', 'IT', 'C11089'],
];

const employer_pages = [
  ['Finance and Accounting', 'finance and accounting', '/clients/finance-and-accounting'],
  ['Information Technology', 'information technology', '/clients/information-technology'],
  ['Administrative and Human Resources', 'administrative and human resources', '/clients/administrative-human-resources'],
  ['Non Clinical Healthcare', 'non clinical healthcare', '/clients/non-clinical'],
];

const Form = (function() {
  const Component = Inferno.Component;

  const startsWithVowel = string => ['a','e','i','o','u'].indexOf(string.toLowerCase()[0]) !== -1
  const toSentence = (arr, ) => arr.length > 2
    ? arr.slice(0, -2).join(', ') + (arr.slice(0, -2).length ? ', ' : '') + arr.slice(-2).join(', and ')
    : arr.join(' and ');

  class Choice extends Component {
    constructor(props) {
      super(props);
      this.clickHandler = this.clickHandler.bind(this);
    }
    clickHandler() {
      this.props.event(this.props.subject, this.props.values);
    }
    render() {
      const text = this.props.values[1];
      const selected = !!this.props.selected;
      return <li class={ selected ? 'selected' : '' }><a href="#" onClick={this.clickHandler} >{ text }</a></li>
    }
  }

  class Toggle extends Choice {
    constructor(props) {
      super(props);
      this.clickHandler = this.clickHandler.bind(this);
    }
    clickHandler() {
      this.props.event(this.props.subject, this.props.values, this.props.value);
    }
    render() {
      const text = this.props.values[1];
      const selected = !!this.props.selected;
      return <li class={ selected ? 'toggle selected' : 'toggle' }><a href="#" onClick={this.clickHandler} >{ text }</a></li>
    }
  }

  class Link extends Choice {
    constructor(props) {
      super(props);
    }
    render() {
      const text = this.props.values[1];
      const selected = !!this.props.selected;
      const url = this.props.values[2];
      return <li class={ selected ? 'selected' : '' }><a href={ url }>{ text }</a></li>
    }
  }

  class App extends Component {
    constructor(props) {
      super(props);

      this.state = {
        step: 0,
        value: '',
        who: ['','',''],
        seeking: {},
        industry: [],
        keyword: [''],
        responseData: '',
      };

      this.toggleModal = this.toggleModal.bind(this);
      this.dismiss = this.dismiss.bind(this);
      this.setChoice = this.setChoice.bind(this);
      this.setToggle = this.setToggle.bind(this);
      this.inputChange = this.inputChange.bind(this);
      // this.step = this.step.bind(this);
      this.generateRequestUrl = this.generateRequestUrl.bind(this);
      this.submit = this.submit.bind(this);
    }

    toggleModal() {
      this.setState({
        modal: !this.state.modal
      });
    }

    dismiss(direction) {
      const curStep = this.state.step;
      const delta = direction && direction < 0
        ? direction
        : 1;

        this.setState({
        modal: false,
      })

      setTimeout(() => {
        this.setState({
          step: this.stepCap(curStep, delta)
        })
      }, 500);
    }

    stepCap(step, delta) {
      const newStep = step + delta;
      const limit = 4;
      return newStep >= limit
        ? 0
        : newStep
    }

    setChoice(key, value) {
      this.setState({
        [key]: value
      });

      this.dismiss();
    }

    setToggle(group, key, value) {
      const cleanKey = key[1];
      const currentToggleState = this.state[group] ? !!this.state[group][cleanKey] : false;
      const setValue = typeof(value) === "boolean";

      const mutableToggleState = Object.assign(this.state[group] || {}, {
        [cleanKey]: setValue ? value : !currentToggleState
      });

      this.setState({
        [group]: mutableToggleState,
      });
    }

    inputChange(event) {
      const target = event.target;
      const type = target.type;
      const name = target.name;
      const snowflake = target.dataset.snowflake;
      const value = type === 'checkbox'
        ? target.checked
        : target.value;

      this.setState({
        [name]: snowflake === 'user_type'
          ? user_type[value]
          : [value, value, value]
      });
    }

    // step(int) {
    //   this.setState({
    //     step: int || this.state.step++
    //   });
    // }

    generateRequestUrl(seekArray, indArray, keyword) {
      const urlBase = 'http://jobs.tewscompany.com/index.smpl';
      // const urlBase = '/jobs/';

      const categories = indArray.map(indString =>
        industries.find(industry => industry[1] === indString)[2]);
      const catParam = '&category=';
      const catRawString = encodeURIComponent(categories.join('|'));
      const catParamString = catParam + categories.join(catParam);

      const emTypes = seekArray.map(emString =>
        employment_types.find(employment => employment[1] === emString)[2]);
      const emTypeParam = '&POST_EMPLOYMENT_TYPE=';
      const emTypeParamString = emTypeParam + emTypes.join(emTypeParam).replace(/ /g, '+');

      // const time = 1513618225 //new Date().getTime();
      // const hash = '31dd78d9e2a6e0c41f97c05dc1b108dd';

      const keywordString = keyword
        ? encodeURIComponent(keyword)
        : '';

      return `${urlBase}?ref_arg=list_posts&pp=20&pid=gwt&first=0&total=0&action=1&save=0&order_select_mobile=26` +
        `&rawcats=${ catRawString }${ catParamString }${ emTypeParamString }&keyword=${ keywordString }`;
    }

    submit(event) {
      alert('A name was submitted: ' + this.state.value);
      event.preventDefault();
      this.goTo();
    }

    goTo(url) {
      window.location.href = url;
      console.log(url, this);
    }

    render() {
      const step = this.state.step;

      // Grammar booleans
      const shouldAn = startsWithVowel(this.state.who[1]);
      const employer = this.state.who[1] === 'employer';

      const whoString = this.state.who[1];
      const keywordString = this.state.keyword[1];

      const seekingArray = Object.keys(this.state.seeking)
        .filter(key => this.state.seeking[key]);
      const seekingString = seekingArray.join(',');
      const seekingGrammarString = toSentence(seekingArray);

      const industryArray = Object.keys(this.state.industry)
        .filter(key => this.state.industry[key]);
      const industryString = industryArray.join(',');
      const industryGrammarString = toSentence(industryArray);
      const shouldPluralize = industryArray.length > 1;

      // const seekingArray = Object.keys(this.state.seeking).map(key => this.state.seeking[key])
      // const seekingGrammarString = toSentence(seekingArray);

      // Booleans for whether a given step has a valid value
      // This determines when to show the next/submit buttons
      // Use true for non-required fields (like the keyword input)
      const stepState = [
        !!whoString,
        !!seekingGrammarString,
        !!industryGrammarString,
        true, //!!keywordString
      ];

      // Generate a valid request URL when user is on the last step
      const requestUrl = step === 3 && stepState[step]
        ? this.generateRequestUrl(seekingArray, industryArray, this.state.keyword[1])
        : '';

      // Form Input Arrays
      const userTypes = user_type.map(user =>
        <Choice
          subject="who"
          values={ user }
          event={ this.setChoice }
          selected={ whoString === user[1] }
        />);

      const employerPages = employer_pages.map(employment =>
        <Link
          subject="seeking"
          values={ employment }
          selected={ !!this.state.seeking[employment[1]] }
        />);

      const employmentChoices = employment_types.map(employment =>
        <Toggle
          subject="seeking"
          values={ employment }
          event={ this.setToggle }
          selected={ !!this.state.seeking[employment[1]] }
        />);

      const industryChoices = industries.map(industry =>
        <Toggle
          subject="industry"
          values={ industry }
          event={ this.setToggle }
          selected={ !!this.state.industry[industry[1]] }
        />);

      return (
        <form onSubmit={this.submit} class={ this.state.modal ? 'modal' : '' }>
          {/* Full Sentence */}
          <h2 class="sentence">
            <span>I am a{ shouldAn ? 'n' : '' } { this.state.who[1] } </span>
            <span>seeking { employer ? 'help in ' : '' }{ seekingGrammarString } positions </span>
            <span>in the field{ shouldPluralize ? 's' : '' } of { industryGrammarString } </span>
            <span>as a { this.state.keyword[1] || '..' }.</span>
          </h2>
          <div class="modal_el" onClick={ this.toggleModal } ></div>
          <div class="field_wrapper">
            <div class="field_group" style={{ transform: `translate3d(-${ step }00%,0,0)` }}>
              {/* "I am a [user type]" */}
              <fieldset class={ step === 0 ? 'active' : '' /*{ this.state.who[0] ? 'selected' : 'undecided'*/}>
                <label>
                  <span class="h1 string" onClick={ this.toggleModal }>I am a{ shouldAn ? 'n' : '' }</span>
                  <div class="input_box h1" onClick={ this.toggleModal }>
                    <span class={ whoString ? 'inter active' : 'inter' }>{ whoString }</span>
                    <hr class="line" />
                  </div>
                  <div class="abyss">
                    <ul>{ userTypes }</ul>
                    <div class="controls">
                      <a href="#" class="back" onClick={ () => this.dismiss(-1) }></a>
                      <a href="#" class="close" onClick={ this.toggleModal }>Close</a>
                      <a href="#" class="next" onClick={ this.dismiss }>Next</a>
                    </div>
                    <select name="who" onInput={this.inputChange} data-snowflake="user_type">
                      {user_type.map(user_type =>
                        <option value={user_type[2]}>{user_type[0]}</option>
                      )}
                    </select>
                  </div>
                  {/* <input type="text" name="who" value={this.state.who[2]} onInput={this.inputChange} /> */}
                </label>
              </fieldset>

              { /* "Seeking [employment options]" */ }
              <fieldset class={ step === 1 ? 'active' : '' /*{ seekingArray.length ? 'selected' : 'undecided'*/}>
                <label>
                  <span class="h1 string" onClick={ this.toggleModal }>seeking { employer ? 'help in ' : '' }</span>
                  <div class="input_box h1" onClick={ this.toggleModal }>
                    <span class={ seekingGrammarString ? 'inter active' : 'inter' }>{ seekingGrammarString }</span>
                    <hr class="line" />
                  </div>
                  <div class="abyss">
                    { employer ? (
                      <ul class="page_links">{ employerPages }</ul>
                    ) : (
                      <ul>{ employmentChoices }</ul>
                    ) }
                    <div class="controls">
                      <a href="#" class="back" onClick={ () => this.dismiss(-1) }>Back</a>
                      <a href="#" class="close" onClick={ this.toggleModal }>Close</a>
                      { !employer && (
                        <a href="#" class="next" onClick={ this.dismiss }>Next</a>
                      ) }
                    </div>
                    <input type="text" name="seeking" value={ seekingString }/> {/*onInput={this.inputChange}*/}
                  </div>
                </label>
              </fieldset>

              { !employer &&
                /* "In the field of [industry]" */
                <fieldset class={ step === 2 ? 'active' : '' /*{ industryArray.length ? 'selected' : 'undecided'*/}>
                  <label>
                    <span class="h1 string" onClick={ this.toggleModal }>in the field{ shouldPluralize ? 's' : '' } of</span>
                    <div class="input_box h1" onClick={ this.toggleModal }>
                      <span class={ industryGrammarString ? 'inter active' : 'inter' }>{ industryGrammarString }</span>
                      <hr class="line" />
                    </div>
                    <div class="abyss">
                      <ul>{ industryChoices }</ul>
                      <div class="controls">
                        <a href="#" class="back" onClick={ () => this.dismiss(-1) }>Back</a>
                        <a href="#" class="close" onClick={ this.toggleModal }>Close</a>
                        <a href="#" class="next" onClick={ this.dismiss }>Next</a>
                      </div>
                      <input type="text" name="industry" value={ industryString } onInput={this.inputChange} />
                    </div>
                  </label>
                </fieldset>
              }

              { !employer &&
                /* "As a [keyword]" */
                <fieldset class={ step === 3 ? 'active' : '' /*{this.state.keyword[1] ? 'selected' : 'undecided'*/}>
                  <label>
                    <span class="h1 string" onClick={ this.toggleModal }>as a</span>
                    <div class="input_box h1" onClick={ this.toggleModal }>
                      <span class={ this.state.keyword[1] ? 'inter active' : 'inter' }>{ keywordString }</span>
                      <hr class="line" />
                    </div>
                    <div hasNonKeyedChildren noNormalize contenteditable="true" onInput={ this.inputChange }>
                      <span >
                        { this.state.keyword[0] || <br /> }
                      </span>
                    </div>
                    <div class="abyss">
                      <input class="visible keyword h1" type="text" name="keyword" placeholder="job title, skills, job id, etc." value={ this.state.keyword[2] } onInput={ this.inputChange } />
                      <div class="controls">
                        <a href="#" class="back" onClick={ () => this.dismiss(-1) }>Back</a>
                        <a href="#" class="close" onClick={ this.toggleModal }>Close</a>
                        <a href="#" class="next" onClick={ () => this.goTo(requestUrl) }>Submit</a>
                      </div>
                    </div>
                  </label>
                </fieldset>
              }
            </div>
          </div>
          <div class="global controls">
            <a href="#" class={ step === 0 ? 'close' : 'hidden' } onClick={ () => $('#app_root').toggleClass('app_on') }>Close</a>
            <a href="#" class={ step > 0 ? 'back' : 'hidden' } onClick={ () => this.setState({ step: this.stepCap(step, -1) }) }>Back</a>
            <a href="#" class={ step < 3 && stepState[step] ? 'next' : 'hidden' } onClick={ () => this.setState({ step: this.stepCap(step, 1) }) }>Next</a>
            <a href="#" class={ step === 3 && stepState[step] ? 'submit' : 'hidden' } onClick={ () => this.goTo(requestUrl) }>Submit</a>
          </div>
          {/* Submit */}
          {/* <input type="submit" value="Submit" /> */}
          {/* <span class="pre">{ requestUrl }</span> */}
          {/* <pre>{ this.state.responseData }</pre> */}
        </form>
      );
    }
  }

  return { App };
}())
